// extracted by mini-css-extract-plugin
export default {"archived":"PersonName_archived__PK290"};